import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ComponentBase, ScanResult, ScanService } from '@definitiv-packages/angular-dba-library';
import { ProjectLanguage, ProjektPermissionService, SafetyPointService } from '../../../../../roofsafetymanagement-library/src/public-api';
import { PermissionService } from '@definitiv-packages/angular-permissions-library';

@Component({
  selector: 'app-safetypointverwaltung-menu',
  templateUrl: './safetypoint-verwaltung-menu.component.html',
  styleUrls: ['./safetypoint-verwaltung-menu.component.scss'],
  standalone: false
})
export class SafetypointVerwaltungMenuComponent extends ComponentBase<ProjectLanguage> implements OnInit, OnDestroy {
  public isDisabled = false;
  

  constructor(

    private router: Router,
    private scanService: ScanService,
    private safetyPointService:SafetyPointService,
    public permissionService:ProjektPermissionService
  ) {
    super();
    //this.scanSubscription = this.scanService.safetyPoint.subscribe(electronicId => this.handleElectronicIdScan(electronicId));
  }

  public async ngOnInit(): Promise<void> {
    try {
      this.loading = true;
    } finally {
      this.loading = false;
    }
  }

  public ngOnDestroy(): void {
    //this.scanSubscription.unsubscribe();
  }

  private async handleScan(electronicId: string): Promise<void> {        
    var safetyPointList = await this.safetyPointService.getFilteredList({ ElectronicId: electronicId });  
    if (safetyPointList.length > 0) {
     // this.router.navigate(['/object-service', safetyPointList[0].ObjektID], { queryParams: { electronicId: electronicId } });
    }
  }
 
}
